import * as React from 'react'
import Input from '@frontrow/console/src/entities/components/base/input'
import {Button} from '@frontrow/console/src/components/button'
import {H3} from '@frontrow/console/src/components/typography'

import SpinnerWrapper from '@frontrow/console/src/components/common/spinner-wrapper'
import ErrorAlert from '@frontrow/console/src/components/common/error-alert'
import WarningIcon from '@frontrow/console/src/components/common/warning-icon'
import FormField from '@frontrow/console/src/components/common/form-field'
import * as style from './student-delete-field.module.scss'

type Props = {
  deleteStudent: (studentId: number) => void
  isDeleting: boolean
  error: string | undefined | null
}

export default function StudentDeleteField(props: Props): React.ReactElement {
  const {isDeleting, error} = props
  const [studentId, setStudentId] = React.useState<number>(NaN)

  const onChangeStudentId = (studentIdString: string) => {
    setStudentId(parseInt(studentIdString, 10))
  }

  const onDelete = (e: React.FormEvent): void => {
    e.preventDefault()
    props.deleteStudent(studentId)
  }

  const errorNode = error !== null && error !== undefined ? <ErrorAlert>{error}</ErrorAlert> : null

  return (
    <div className={style.deleteFieldContainer}>
      <H3>Delete Student Data</H3>
      <p>
        <WarningIcon />
        Permanently deletes <b>all data</b> for a student
        <WarningIcon />
      </p>
      {errorNode}
      <SpinnerWrapper isLoading={isDeleting}>
        <form onSubmit={onDelete} action="">
          <FormField wrapperStyle={style.deleteField} label="Student ID">
            <Input
              value={isNaN(studentId) ? '' : studentId}
              type="number"
              placeholder={'1'}
              onChange={onChangeStudentId}
            />
          </FormField>
          <Button disabled={isNaN(studentId)} type="submit">
            Delete Student Data
          </Button>
        </form>
      </SpinnerWrapper>
    </div>
  )
}
